module.exports = __webpack_public_path__ + "static/img/temp_head_1.f397ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/temp_head_1.png
// module id = mB/v
// module chunks = 10